import { render, staticRenderFns } from "./IconReport.vue?vue&type=template&id=2286585c&scoped=true&"
import script from "./IconReport.vue?vue&type=script&lang=js&"
export * from "./IconReport.vue?vue&type=script&lang=js&"
import style0 from "./IconReport.vue?vue&type=style&index=0&id=2286585c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2286585c",
  null
  
)

export default component.exports